var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.885,
    height: 11,
    viewBox: "0 0 7.885 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1293",
    "data-name": "Group 1293",
    transform: "translate(-510.441 -383.75)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-down-thin",
    d: "M7.03,12.027h3.154V4.994l1.585-.024v7.057h3.146L10.973,15.97Z",
    transform: "translate(503.411 378.78)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.4e2e84478b2ed303aa27959018e12ef6.svg";
export { ForwardRef as ReactComponent };